import { render, staticRenderFns } from "./FooterDocument.vue?vue&type=template&id=bdcaae96&"
import script from "./FooterDocument.vue?vue&type=script&lang=js&"
export * from "./FooterDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports